export enum ReceiptExpensesType {
    PickingListCollect = 1,
    PickingListPay = 2
}